<template>
    <div >
      <app-header class="haeder-r"></app-header>
        <!--slider end -->
        <div v-if="blog" class="box-title">
            <h2>{{blog.title}}</h2>
        </div>
        <div  class="blog-page full-page">
            <div   v-if="blog" class="container">
                <div class="row">
                    <div class="col-md-12 col-xs-12 col-sm-12 col-md-12 lightgallery">
                        <a :href="blog.image">
                          <div class="box-big-img-project" :style="'background-image: url('+blog.image+')'"></div>
                        </a>
                    </div>
                </div>
                <div class="row">
                    <div class="blog-content">
                        <div class="container">
                          <div class="row">
                            <div class="col-md-12 col-xs-12 col-ms-12 col-lg-12">
                              <p v-html="blog.content"></p>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      <app-footer></app-footer>
    </div>
</template>

<script>

 import {Urls,checkForDub} from '../config'

  export default {

    mounted(){
      let pathArray = window.location.pathname.split( '/' );
      this.slug = pathArray[pathArray.length - 1]
      this.getBlog()
    },
    data(){
      return{
          loading : false,
          slug : '',
      }
    },
    methods:{
        getBlog(link){
            this.loading = true
            this.axios.get(Urls.blogsUrl+'/'+this.slug)
              .then((response) => {
                // Success
                this.loading = false
                setTimeout( () => {
                try {
                    $(".lightgallery").lightGallery({
                    controls : false,
                    enableSwipe : false,
                    })
                } catch (e) {ce(e)}
                },100)
                if(response.status === 200){
                    this.pagination = response.data.meta
                    if(! checkForDub(this.blogs, response.data.data)){
                      this.$store.commit('blog/add',  response.data.data)
                    }
                }
              }).catch((errors) => {
              // error
              this.loading = false
              console.log(errors)
              this.err = errors
            })
        },
        getCurrentPage(index){
             if(index === this.pagination.current_page){
                return "active"
              }

        },

    },
    computed:{
        blogs(){
            return this.$store.state.blog.blog
        },
        blog(){
            return this.blogs.filter(blog => blog.slug === this.slug)[0]
        },
        similar(){
            return this.$store.state.similar.similar
        },
        url(){
          let furl = location.href.replace(/https?:\/\//i, "")
          let curl = furl.split( '/' );
          return  curl[0];
        }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/blog.vue